import { createRoot } from 'react-dom/client';

import { App } from './app';

const rootEl = document.createElement('div');
rootEl.id = 'root';
document.body.appendChild(rootEl);

const root = createRoot(rootEl);
root.render(<App />);
